import { CompanyLocationModel } from './companyLocationModel';

export class AddCompanyLocationModel extends CompanyLocationModel {
}
